module.exports = __webpack_public_path__ + "static/media/CV-SaraArellano-ES.4069f2c2.pdf";